import common from './common';
function getParam(data) {
  let url = '';
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : '';
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}
/**
 * app
 * 核心全局app方法
 */
const app = {
  checkAccount(){
    if (navigator.general) {
      navigator.general.checkAccount();
    } else {
      this.deviceready(function () {
        navigator.general.checkAccount();
      })
    }
  },
  // 用新的webview打开页面
  openWeb(url, parasm) {
    if (parasm) {
      url += (url.indexOf('?') < 0 ? '?' : '&') + getParam(parasm);
    }
    if (common.isApp) {
      let hrefs = "fqyf://web?url=" + encodeURIComponent(url);
      this.router({ url: hrefs });
    } else {
      location.href = url;
    }
  },
  // 打开微信
  openWechat() {
    navigator.wechat.jumpToWechat();
  },
  //获取用户信息
  getUserInfo: function (success, fail) {
    if (navigator.general) {
      navigator.general.getUserInfo(success, fail);
    } else {
      this.deviceready(function () {
        navigator.general.getUserInfo(success, fail);
      })
    }
  },
  // 获取app相关信息
  getDeviceInfo: function (success, fail) {
    navigator.general.getDeviceInfo && navigator.general.getDeviceInfo(success, fail);
    // navigator.general.getDeviceToken(success,fail);
  },
  //通知app退出登录
  loginOut: function (success, fail) {
    navigator.general.logout(success, fail);
  },
  //获取客服电话
  getServicerPhone: function (success, fail) {
    if (!common.isApp) {
      success("400-8700-100");
      return;
    }
    if (navigator.general) {
      navigator.general.getServicerPhone(success, fail);
    } else {
      this.deviceready(function () {
        navigator.general.getServicerPhone(success, fail);
      })
    }
  },
  //获取字典数据
  getSystemReadDic: function (params, success, fail) {
    console.log("getSystemReadDic", navigator.general);
    if (navigator.general) {
      navigator.general.getSystemReadDic(params, success, fail);
    } else {
      this.deviceready(function () {
        navigator.general.getSystemReadDic(params, success, fail);
      })
    }
  },
  /**
   * type: 1：文字 2：图片
   * router：点击动作
   * content：1：显示的文字 2：图片地址
   * navigator.general.titleMenu(type,router,content);
   *
   */
  titleMenu(content, router, type = 1) {
    const params = {
      type,
      router,
      content
    }
    if (navigator.general) {
      navigator.general.titleMenu&&navigator.general.titleMenu(params);
    } else {
      this.deviceready(function () {
        navigator.general.titleMenu&&navigator.general.titleMenu(params);
      })
    }
  },
  /**
   * 隐藏右上角按钮
   */
  hideTitleMenu() {
    if (common.isApp) {
      navigator.general.hideTitleMenu&&navigator.general.hideTitleMenu();
    }
  },
  /**初始化分享*
   * params:{
          router (链接)
          路由：
          wts://share?type=1(分享网页链接)&link=&title=&content=&logo=
          wts://share?type=2(分享图片)&link=(图片链接)
          wts://share?type=3(分享小程序)&link=&title=&content=&logo=&userName=&path=
          wts://share?type=4(文本)&link=&title=&content=&logo=&userName=&path=
      }
      * **/
  initShare: function (params, success, fail) {
    let url = "fqyf://share?type=1"
      + "&link=" + encodeURIComponent(params.link)
      + "&content=" + encodeURIComponent(params.content)
      + "&title=" + encodeURIComponent(params.title)
      + "&logo=" + encodeURIComponent(params.logo || (location.origin + "/m/bdgj/public/images/share_logo.jpg"));
    console.log(url)
    if (navigator.general) {
      navigator.general.rightIcon({ router: url }, success, fail);
    } else {
      this.deviceready(function () {
        navigator.general.rightIcon({ router: url }, success, fail);
      })
    }
  },
  hideRightIcon() {
    if (!common.isApp) {
      return;
    }
    if (navigator.general) {
      navigator.general.hideRightIcon && navigator.general.hideRightIcon();
    } else {
      this.deviceready(function () {
        navigator.general.hideRightIcon && navigator.general.hideRightIcon();
      })
    }
  },
  // 打开分享面板
  openSharePanel(params) {
    var url = 'fqyf://share?type=1&title=' + encodeURIComponent(params.title)
      + '&content=' + encodeURIComponent(params.content)
      + '&logo=' + encodeURIComponent(params.logo)
      + '&link=' + encodeURIComponent(params.link);
    if (params.target) {
      url += "&target=" + params.target;
    }
    console.log("openSharePanel", url)
    this.router({ url });
  },
  /**
   * 直接拉起分享
   * 海报参数poster={"action":"url","message":"提示","has":"0或1"}
      fqyf://share?type=(必传)&link=(必传)&title=(非必传)&content=(非必传)
      &logo=(非必传)&poster=({"action":"","message":"","has":""},非必传)
      &target=(pyq、wx、dingding，非必传)
   * @param {*} params
   */
  openShare(params, success, fail) {
    let url = "fqyf://share?type=" + params.type
      + "&link=" + encodeURIComponent(params.link)
      + "&target=" + (params.target || 'wx');
    if (params.type == 1) {
      url += "&content=" + encodeURIComponent(params.content)
        + "&logo=" + encodeURIComponent(params.logo || (location.origin + "/m/bdgj/public/images/share_logo.jpg"))
    }
    try {
      if (params.poster) {
        url += "&poster=" + encodeURIComponent(JSON.stringify(params.poster));
      }
    } catch (error) {
      console.log("写入poster参数失败")
    }
    console.log("openShare", url)
    navigator.general.router({
      url: url
    }, success, fail);
  },
  /**打开微信小程序*
   * params:{
          userName (小程序appid)
          path (小程序页面路径)
          miniProgramType (小程序类型 0:正式版  1:开发版  2:体验版)
      }
      * **/
  openMiniProgram: function (params, success, fail) {
    navigator.wechat.openMiniProgram(params, success, fail);
  },


  /**打开app内置页面*
   * params:{
          url (页面路径)
          title (页面标题  可选参数)
      }
      * **/
  router: function (params, success, fail) {
    if (navigator.general) {
      navigator.general.router(params, success, fail);
    }else{
      this.deviceready(function () {
        navigator.general.router(params, success, fail);
      })
    }
  },

  /**关闭当前webview页面*
   * **/
  closeWebView: function () {
    if (navigator.general) {
      navigator.general.close();
    }else{
      this.deviceready(function () {
        navigator.general.close();
      })
    }
  },

  /**pdf预览*
   * params:{
          url (pdf链接)
          title (页面标题  可选参数)
      }
      * **/
  readPdf: function (params) {
    navigator.general.readPdf(params);
  },
  /**下载*
   * params:{
          url (图片链接)
          type (文件类型:image  audio video)
      }
      * **/
  download: function (params) {
    navigator.general.download(params);
  },

  /**打开视频播放*
* params:{
    url (视频链接)
  }
  * **/
  playVideo: function (params, success, fail) {
    navigator.general.playVideo(params, success, fail);
  },

  //视频上传人脸识别
  uploadRecognition: function (success, fail) {
    navigator.general.uploadRecognition(success, fail);
  },

  /**设备初始化*
   *callback
      * **/
  deviceready: function (callback) {
    if (common.isApp) {
      document.addEventListener('deviceready', function () {
        console.log("deviceready")
        callback();
      }, false);
    } else {
      callback();
    }
  }
}
export default app;
